export enum GlobalErrorType {
  FORBIDDEN = 'FORBIDDEN',
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  UNKNOWN = 'UNKNOWN',
  GRAPHQL = 'GRAPHQL',
}

export interface IGlobalException {
  data?: any;
  error?: any;
  status: string;
  type: GlobalErrorType;
}
